/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_venn_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste one column of items per set to draw a two- or three-set Venn diagram. The number of items unique to each set and shared between them is counted automatically and shown in each region.`)
};

const es_venn_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega una columna de elementos por conjunto para dibujar un diagrama de Venn de dos o tres conjuntos. El número de elementos únicos de cada conjunto y compartidos entre ellos se cuenta automáticamente y se muestra en cada región.`)
};

const de_venn_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge eine Spalte mit Elementen pro Menge ein, um ein Venn-Diagramm mit zwei oder drei Mengen zu zeichnen. Die Anzahl der Elemente, die für jede Menge eindeutig sind und zwischen ihnen geteilt werden, wird automatisch gezählt und in jeder Region angezeigt.`)
};

const nl_venn_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak één kolom items per set om een Venn-diagram met twee of drie sets te tekenen. Het aantal items dat uniek is voor elke set en gedeeld wordt tussen sets, wordt automatisch geteld en getoond in elke regio.`)
};

const fr_venn_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez une colonne d'éléments par ensemble pour tracer un diagramme de Venn à deux ou trois ensembles. Le nombre d'éléments propres à chaque ensemble et partagés entre eux est compté automatiquement et affiché dans chaque région.`)
};

const it_venn_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla una colonna di elementi per insieme per disegnare un diagramma di Venn a due o tre insiemi. Il numero di elementi unici a ciascun insieme e condivisi tra loro viene contato automaticamente e mostrato in ogni regione.`)
};

const pt_br2_venn_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma coluna de itens por conjunto para desenhar um diagrama de Venn de dois ou três conjuntos. O número de itens exclusivos de cada conjunto e compartilhados entre eles é contado automaticamente e mostrado em cada região.`)
};

const pt_venn_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma coluna de itens por conjunto para desenhar um diagrama de Venn de dois ou três conjuntos. O número de itens exclusivos de cada conjunto e partilhados entre eles é contado automaticamente e apresentado em cada região.`)
};

const ja_venn_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集合ごとに項目を1列貼り付けて、2集合または3集合のベン図を描画します。各集合に固有の項目数と、集合間で共有されている項目数は自動的に集計され、各領域に表示されます。`)
};

const zh_venn_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每组粘贴一列项目，即可绘制两组或三组维恩图。系统会自动计算每组独有的项目数量以及各组之间共享的项目数量，并显示在对应区域中。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const venn_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.venn_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("venn_intro", locale)
	if (locale === "en") return en_venn_intro(inputs)
	if (locale === "es") return es_venn_intro(inputs)
	if (locale === "de") return de_venn_intro(inputs)
	if (locale === "nl") return nl_venn_intro(inputs)
	if (locale === "fr") return fr_venn_intro(inputs)
	if (locale === "it") return it_venn_intro(inputs)
	if (locale === "pt-BR") return pt_br2_venn_intro(inputs)
	if (locale === "pt") return pt_venn_intro(inputs)
	if (locale === "ja") return ja_venn_intro(inputs)
	return zh_venn_intro(inputs)
};